import { createFileRoute, notFound, useLoaderData } from "@tanstack/react-router";
import Navigation from "@/features/navigation";
import { UnsubscribeSuccess, decodeUnsubscribePayload } from "@/features/unsubscribe";

const Component = () => {
  const data = useLoaderData({ from: "/_public/notifications/unsubscribe/success/$payload/" });

  return (
    <Navigation variant="reduced">
      <UnsubscribeSuccess websiteName={data.websiteName} email={data.email} notificationType={data.notificationType} />
    </Navigation>
  );
};

const Route = createFileRoute("/_public/notifications/unsubscribe/success/$payload/")({
  loader: async ({ params: { payload } }) => {
    const signingKey = import.meta.env.VITE_UNSUBSCRIBE_PAYLOAD_SIGNING_KEY;
    const data = signingKey ? await decodeUnsubscribePayload(payload, signingKey) : null;

    if (!data) {
      // eslint-disable-next-line @typescript-eslint/no-throw-literal -- TanStack Router not-found control flow
      throw notFound();
    }

    return data;
  },
  component: () => <Component />,
});

export { Route };
